var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',[_c('ActionButton',{attrs:{"action":_vm.downloadCsv}},[_vm._v("CSV")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }